import React, { useState } from 'react';
import { Input, Button, Alert, Card, Typography, Space, Spin } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { ReportAPI } from '../../../apis/ReportAPI';

const { Title, Paragraph } = Typography;

export default function AlphaPrompt() {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleAsk = async (e) => {
    e.preventDefault();
    
    if (!question.trim()) return;
    
    setLoading(true);
    setIsError(false);
    setAnswer('');

    try {
      const response = await ReportAPI.getPromptAI({"question": question});
      const responseData = response.data; // Extract data from axios response
      
      // Check if the API returned an error in the response body
      if (responseData.error) {
        setAnswer(responseData.error);
        setIsError(true);
      } else if (responseData.answer) {
        setAnswer(responseData.answer);
        setIsError(false);
      } else {
        setAnswer('No answer received from the server');
        setIsError(true);
      }
    } catch (err) {
      // This will catch network errors or 500 status codes
      if (err.response && err.response.data && err.response.data.error) {
        // Axios puts error responses in err.response.data
        setAnswer(err.response.data.error);
      } else {
        setAnswer(err.message || 'An unexpected error occurred');
      }
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setQuestion(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAsk(e);
    }
  };

  return (
    <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
      <Title level={2} style={{ marginBottom: '24px' }}>
        Alpha AI Prompt
      </Title>

      <Card style={{ marginBottom: '24px' }}>
        <form onSubmit={handleAsk}>
          <Space.Compact style={{ width: '100%' }}>
            <Input
              placeholder="Enter your question..."
              value={question}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              size="large"
              disabled={loading}
              style={{ flex: 1 }}
            />
            <Button
              type="primary"
              htmlType="submit"
              icon={<SendOutlined />}
              size="large"
              loading={loading}
              disabled={!question.trim()}
            >
              {loading ? 'Asking...' : 'Ask'}
            </Button>
          </Space.Compact>
        </form>
      </Card>

      {loading && (
        <Card style={{ marginBottom: '24px', textAlign: 'center' }}>
          <Spin size="large" />
          <Paragraph style={{ marginTop: '16px', marginBottom: 0 }}>
            Processing your question...
          </Paragraph>
        </Card>
      )}

      {answer && !loading && (
        <Card
          title={isError ? "Error" : "Summary"}
          style={{ marginBottom: '24px' }}
          headStyle={{ 
            backgroundColor: isError ? '#fff2f0' : '#f0f2f5',
            borderBottom: isError ? '1px solid #ffccc7' : '1px solid #d9d9d9'
          }}
        >
          <Paragraph
            style={{
              backgroundColor: isError ? '#fff2f0' : '#fafafa',
              padding: '16px',
              borderRadius: '6px',
              marginBottom: 0,
              whiteSpace: 'pre-wrap',
              color: isError ? '#a8071a' : 'inherit',
              border: isError ? '1px solid #ffccc7' : '1px solid #f0f0f0'
            }}
          >
            {answer}
          </Paragraph>
        </Card>
      )}
    </div>
  );
}